export default __webpack_public_path__ + "static/media/cat_logo.6935dbf9.png";